
import { Options, Vue } from 'vue-class-component';
import { GarmentClient, GarmentDefaultDataClient, GarmentIndustrialClient } from '@/services/Services';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class Garment extends Vue {

    items: OM.TextIdentifier[] = [];
    standaloneItems: OM.GarmentIndustrialConfig[] = [];

    created() {
        Promise.all([
            GarmentClient.getAllAdminConfigurations(),
            GarmentIndustrialClient.getAllStandaloneGarments()
        ]).then(xs => {
            this.items = xs[0];
            this.standaloneItems = xs[1];
        })
    }

    parentGarmentName(item: OM.GarmentIndustrialConfig) {
        return this.items.find(x => x.identifier == item.sourceGarmentConfigId)?.text || item.sourceGarmentConfigId;
    }

    standaloneConfiguration(garmentIdentifier: string) {
        return this.standaloneItems.find(x => x.garmentConfigId == garmentIdentifier);
    }

    editGarment(garmentId: string) {
        if(garmentId == '0')
            this.$router.push('/garment/' + garmentId);
        else {
            GarmentClient.checkIsFootwear(garmentId)
            .then(x => {
                if(x)
                    this.$router.push('/footwear/' + garmentId);
                else
                    this.$router.push('/garment/' + garmentId);
            })
        }
    }

    defaultData(garmentId: string){
        GarmentDefaultDataClient.checkExisting(garmentId)
        .then(x => {
            this.$router.push('/garmentDefaultData/editbaseinformation/' + x);
        })
    }

}
